<template>
  <div class="open-xcx-page">
    <div class="xcx-info">
      <img class="logo" src="../../assets/img/xcx-sht.png" alt="" />
      <h3 class="name">海科商户通</h3>
      <p class="tips">小程序</p>
    </div>
    <div class="link-info">
      <p class="button">
        <span class="goto-btn" :class="{ disabled: url === '' }" @click="openWeapp"
          >前往微信打开</span
        >
      </p>
      <p class="link">
        无法打开时，可以使用默认浏览器打开。<span class="copy-btn" @click="copyLink"
          >复制链接</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import { copyText } from "@/assets/js/common";

Vue.use(Toast);

export default {
  data() {
    return {
      // url: "weixin://dl/business/?t=p8obUfy0O6j",
      url: "",
    };
  },
  created() {
    document.title = "打开“海科商户通”小程序";
    this.getUrl();
  },
  mounted() {},
  methods: {
    getUrl() {
      this.$baseUrl("/wechat/openlink", {})
        .then((res) => {
          if (res.data.code === "0000") {
            this.url = res.data.data;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 打开小程序
    openWeapp() {
      // console.log(this.url);
      if (this.url !== "") {
        location.href = this.url;
      }
    },
    // 复制链接
    copyLink() {
      copyText(window.location.href);
      Toast("复制成功");
    },
  },
};
</script>

<style scoped>
.open-xcx-page {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: #fff;
  justify-content: center;
  align-items: center;
}
.xcx-info {
  text-align: center;
}
.xcx-info .logo {
  display: block;
  width: 100px;
  height: 100px;
  border-radius: 100%;
}
.xcx-info .name {
  margin-top: 20px;
  font-size: 20px;
  font-weight: normal;
}
.xcx-info .tips {
  display: inline-block;
  margin-top: 20px;
  padding-left: 24px;
  font-size: 18px;
  color: #b1b1b1;
  background: url(../../assets/img/xcx-icon.png) left center no-repeat;
  background-size: auto 20px;
}
.link-info {
  margin-top: 200px;
  text-align: center;
}
.link-info .button {
  text-align: center;
}
.link-info .goto-btn {
  display: block;
  margin: 0 auto;
  width: 250px;
  height: 40px;
  font-size: 16px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  border-radius: 5px;
  background: #05c160;
}
.link-info .goto-btn.disabled {
  opacity: 0.5;
}
.link-info .link {
  margin-top: 20px;
  font-size: 14px;
  color: #818181;
}
.link-info .copy-btn {
  color: #59718d;
}
</style>
